import { render, staticRenderFns } from "./NewTasks.vue?vue&type=template&id=50270d66&scoped=true&"
import script from "./NewTasks.vue?vue&type=script&lang=js&"
export * from "./NewTasks.vue?vue&type=script&lang=js&"
import style0 from "./NewTasks.vue?vue&type=style&index=0&id=50270d66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50270d66",
  null
  
)

export default component.exports